import { render, staticRenderFns } from "./PostQuestion.vue?vue&type=template&id=20d3c7c0&"
import script from "./PostQuestion.vue?vue&type=script&lang=js&"
export * from "./PostQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports